import modular from 'modujs'
import {
  CSS_CLASS,
  ENV
} from './config'
import globals from './globals'
import * as modules from './modules'
import shared from './shared'
import { $html } from './utils/dom'

// eslint-disable-next-line new-cap
const app = new modular({ modules })

function init() {
  globals()
  shared()

  app.init(app)

  $html.classList.add(CSS_CLASS.LOADED, CSS_CLASS.READY)
  $html.classList.remove(CSS_CLASS.LOADING)

  if (ENV.IS_TOUCH) {
    $html.classList.add(CSS_CLASS.TOUCH)
  }

  if (navigator.userAgent.toLowerCase().includes('firefox')) {
    $html.classList.add('is-firefox')
  }

  const mm = window.matchMedia('(any-pointer:coarse)')

  mm.addEventListener('change', () => {
    $html.classList.toggle(CSS_CLASS.TOUCH, mm.matches)
  })
}

////////////////
// Execute
////////////////
window.addEventListener('load', () => {
  init()
  window.dispatchEvent(new Event('p-loaded'))
  window.dispatchEvent(new Event('play-intro'))
})
